import React, {useEffect, useState} from 'react';
import {deleteP5, fetchP5, fixupTime, getDateString, getNewDate, pickString, postP5} from "../Utils";
import {Link, useNavigate} from 'react-router-dom';
import {
    Select, TableCell,
} from "@mui/material";
import Button from "@mui/material/Button";
import FootballEventCell from "../components/FootballEventCell";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import purify from "dompurify";
import TableHead from "@mui/material/TableHead";
import SmackboardTable from "../components/SmackboardTable";

function BowlMania(props) {

    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [config, setConfig] = useState({});
    const [submitPicksResult, setSubmitPicksResult] = useState("");
    const [picksData, setPicksData] = useState([]);
    const [scoresData, setScoresData] = useState([]);
    const [entries, setEntries] = useState([]);
    const [smackData, setSmackData] = useState([]);
    const [smackPostEnabled, setSmackPostEnabled] = useState(true);
    const [standingsData, setStandingsData] = useState([]);

    let defaultEntryId = 0;
    const savedEntryId = localStorage.getItem('bowlmania_entry_id');
    if (savedEntryId) {
        defaultEntryId = Number(savedEntryId);
    } else if (props.getState().bowlmania && props.getState().bowlmania.data && props.getState().bowlmania.data.config && props.getState().bowlmania.data.config.data && props.getState().bowlmania.data.config.data[0]) {
        defaultEntryId = props.getState().bowlmania.data.config.data[0].entry_id;
        localStorage.setItem('bowlmania_entry_id', defaultEntryId);
    }
    const [entryId, setEntryId] = useState(defaultEntryId);
    const [contestId, setContestId] = useState(0);

    const fetchData = () => {
        fetchP5(props.getState().userName, props.getState().password, '/api/v1/bowlmania/pagedata', 'bowlmania', props)
            .then(data => {
                const config = props.getState().bowlmania.data.config.data;
                setConfig(config);
                setEntryId(config.entry_id);
                setContestId(config.contest_id);
                localStorage.setItem('bowlmania_contest_id', config.contest_id);
                setPicksData(props.getState().bowlmania.data.picks.data);
                processPicksData(props.getState().bowlmania.data.picks.data);
                setScoresData(props.getState().bowlmania.data.scores.data);
                setSmackData(props.getState().bowlmania.data.smack.data);
                setStandingsData(props.getState().bowlmania.data.standings.data);
                if (isLoading) {
                    setIsLoading(false);
                }
            });
    };

    useEffect(() => {
        document.title = "Pick 5 BowlMania";
        if (!props.getState().isLoggedIn) {
            return navigate("/");
        }
        if (isLoading) {
            fetchData();
        }
    }, []);

    function processPicksData(picksData) {
        // sort picks by entryId then process the picks into entries
        const entriesMap = new Map();
        picksData.forEach((pick) => {
            if (!entriesMap.has(pick.entryId)) {
                entriesMap.set(pick.entryId, {
                    entryId: pick.entryId,
                    entry_name: pick.entry_name,
                    picks: [],
                    points: 0,
                    max: 0
                });
            }
            const entry = entriesMap.get(pick.entryId);
            entry.picks.push(pick);
            if (pick.Result === 1) {
                entry.points += pick.Confidence;
                entry.max += pick.Confidence;
            }
            else if (pick.Result !== 0) {
                entry.max += pick.Confidence;
            }
        });
        setEntries(Array.from(entriesMap.values()).sort((a, b) => b.points - a.points));
    }

    function renderLoading() {
        return <div>Loading</div>;
    }

    function pickSortFn(a, b) {
        // Sort the picks by Result (0 or 1 at the end) then by gametime ascending
        if ((a.Result === 1 || a.Result === 0) && (b.Result === 1 || b.Result === 0)) {
            return new Date(b.gametime) - new Date(a.gametime);
        }
        if (a.Result === 0 || a.Result === 1) {
            return 1;
        }
        if (b.Result === 0 || b.Result === 1) {
            return -1;
        }
        return new Date(a.gametime) - new Date(b.gametime);;
    }

    function handleSmackPostMessage(message, onSuccess) {
        setSmackPostEnabled(false);
        postP5(props.getState().userName, props.getState().password, '/api/v1/bowlmania/smack', {
            'Message': message
        })
            .then(response => response.json())
            .then(() => {
                fetchData();
                setSmackPostEnabled(true);
                onSuccess();
            });
    }

    function handleSmackDeleteMessage(messageId) {
        deleteP5(props.getState().userName, props.getState().password, '/api/v1/bowlmania/smack?id=' + messageId)
            .then(response => response.json())
            .then(() => {
                setSmackData([...smackData.filter((message) => message.ID !== Number(messageId))]);
            });
    }

    function renderPicksTable() {
        return (<div>
            <TableContainer>
                <Table size="small" className="BowlManiaPicksTable">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Total</TableCell>
                            <TableCell>Max</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {entries.map((entry) => {
                            return (
                                <TableRow key={`${entry.entryId}_row`}>
                                    <TableCell className="BowlManiaEntryNameCell">{entry.entry_name}</TableCell>
                                    <TableCell className="BowlManiaPointCell">{entry.points}</TableCell>
                                    <TableCell className="BowlManiaPointCell">{entry.max}</TableCell>
                                    {entry.picks.sort(pickSortFn).map((pick) =>
                                        <TableCell className={
                                            `BowlManiaPickCell ${pick.Result === 1 ? 
                                                'BowlManiaPickCellWinner' : 
                                                pick.Result === 0 ?
                                                    'BowlManiaPickCellLoser' :
                                                    pick.mustWin === 1 ?
                                                        'BowlManiaPickCellMustWin' :
                                                        pick.mustLose === 1 ?
                                                            'BowlManiaPickCellMustLose' :
                                                    ''}
                                                    `} key={`pick_${pick.ID}_cell`}>
                                            <div>{pick.abbreviation}</div>
                                            <div>{pick.Confidence}</div>
                                        </TableCell>
                                    )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="BowlManiaLegendContainer">
                * Yellow games are 'Must Win'<br/>
                * Pink games are 'Must Lose'
            </div>
        </div>);
    }

    function dayFormat(day) {
        return getDateString(day);
    }

    function scoresSortFn(a,b) {
        const aFinal = (a.started === 1 && a.timeLeft === 0 && a.status !== 'OT');
        const bFinal = (b.started === 1 && b.timeLeft === 0 && b.status !== 'OT');

        if (aFinal !== bFinal)
            return aFinal ? 1 : -1;

        if (a.started !== b.started) {
            if (a.inProgress !== b.inProgress) {
                return a.inProgress ? -1 : 1;
            }
            else {
                return a.started ? -1 : 1;
            }
        }

        if (a.day !== b.day) {
            const aDate = getNewDate(a.day + "-00:00"), bDate = getNewDate(b.day + "-00:00");
            if (aFinal) {
                return bDate - aDate;
            }
            else {
                return aDate - bDate;
            }
        }

        return a.team1.localeCompare(b.team1);
    }

    function renderScoresTable() {
        return (
            <div className="BowlManiaScoresTableContainer">
                <h3>Scores</h3>
                <Table className="BowlManiaScoresTable" size="small">
                    <TableBody>
                        {scoresData.sort(scoresSortFn).map((ev) => {
                            return (<TableRow key={'pickEvent'+ev.ID}>
                                <TableCell>
                                    <FootballEventCell
                                        team1={ev.team1}
                                        team2={ev.team2}
                                        score1={ev.score1}
                                        score2={ev.score2}
                                        started={!!ev.started}
                                        inProgress={!!ev.inProgress}
                                        status={!!ev.started ? ev.status : ''}
                                        day={ev.day}
                                        eventId={Number(ev.ID)}
                                        dayFormat={dayFormat}
                                        team1Class=""
                                        team2Class=""
                                        team1Rank={ev.Rank1}
                                        team2Rank={ev.Rank2}
                                        statusNote={ev.statusNote}
                                    />
                                </TableCell>
                            </TableRow>);
                        })}
                    </TableBody>
                </Table>
            </div>
        );
    }

    function winPctSortFn(a, b) {
        if (a.winPct === b.winPct) {
            return a.entry_name.localeCompare(b.entry_name);
        }
        return b.winPct - a.winPct;
    }

    function renderWinPctTable() {
        return (
            <div>
                <h3>Win Percent</h3>
                <Table className="BowlManiaWinPctTable" size="small">
                    <TableBody>
                        {standingsData.sort(winPctSortFn).map((ev) =>
                            <TableRow key={`BowlManiaWinPctRow${ev.id}`}>
                                <TableCell>{ev.entry_name}</TableCell>
                                <TableCell>{ev.winPct}%</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
        );
    }

    function renderSmackBoard() {
        return (
            <div className="BowlManiaSmackboardContainer">
                <SmackboardTable
                    smackboardData={smackData}
                    myEntryName={config.entry_name}
                    onPostMessage={handleSmackPostMessage}
                    onDeleteMessage={handleSmackDeleteMessage}
                    postButtonEnabled={smackPostEnabled}
                />
            </div>
        );
    }

    function renderData() {
        return (<div>
            <h2>Bowl Mania</h2>
            <div>
                <Link className="ContestLink" to="/accountsettings" key='link-accountsettings'>Account Settings</Link>
                <Link className="ContestLink" to="makepicks" key='link-bowlmaniamakepicks'>Make Picks</Link>
                <Link className="ContestLink" to="rules" key='link-bowlmaniarules'>Rules</Link>
            </div>
            {renderPicksTable()}
            <div className="BowlManiaBottomRow">
                {renderScoresTable()}
                {renderWinPctTable()}
                {renderSmackBoard()}
            </div>
        </div>);
    }

    return (
        <div>
            {isLoading ? renderLoading() : renderData()}
        </div>
    );
}

export default BowlMania;